export default __webpack_public_path__ + "static/media/surisuri_thumb.1c3cd421.png";